export const TOOLKIT = [
  "NUBII_TOOLS_MESSAGE_IMAGE_UPLOADED",
  "NUBII_TOOLS_MESSAGE_NEW_POLL",
  "NUBII_TOOLS_MESSAGE_PPPS_REMINDER",
];
